/* Footer – Secondary menu drawer toggle */
(function () {
  var footer = document.querySelector('.shopify-section--footer');
  if (!footer) return;

  var toggle = footer.querySelector('[data-footer-secondary-toggle]');
  var secondaryList = footer.querySelector('.footer__secondary-block-list');
  if (!toggle || !secondaryList) return;

  toggle.addEventListener('click', function () {
    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    secondaryList.classList.toggle('footer__secondary-block-list--hidden');
  });
})();
